:root ._dsp-flex{display:flex;}
:root ._items-stretch{align-items:stretch;}
:root ._fb-auto{flex-basis:auto;}
:root ._bxs-border-box{box-sizing:border-box;}
:root ._pos-relative{position:relative;}
:root ._minH-0px{min-height:0px;}
:root ._minW-0px{min-width:0px;}
:root ._shrink-0{flex-shrink:0;}
:root ._fd-column{flex-direction:column;}
:root ._z-1{z-index:1;}
@media (max-width: 430px){:root:root ._pr-_xs_t-space-lar102228{padding-right:var(--t-space-larger);}}
@media (max-width: 430px){:root:root ._pl-_xs_t-space-lar102228{padding-left:var(--t-space-larger);}}
:root ._fd-row{flex-direction:row;}
:root ._items-center{align-items:center;}
:root ._height-50px{height:50px;}
:root ._justify-space-betwe3241{justify-content:space-between;}
:root ._justify-flex-end{justify-content:flex-end;}
:root ._pl-t-space-lar102228{padding-left:var(--t-space-larger);}
:root ._self-stretch{align-self:stretch;}
:root ._gap-t-space-sma3456{gap:var(--t-space-small);}
:root ._cur-pointer{cursor:pointer;}
:root ._pr-t-space-med104641{padding-right:var(--t-space-medium);}